import config from "config/config";
import { AccountService } from "services/account/accountService";
import { HttpClientService } from "services/httpClient/httpClientService";
import { ApiResponse } from "../apiResponse";
import { LogbogPushNotificationRegisterRequestModel } from "./logbogPushNotificationRegisterRequestModel";
import { LogbogPushNotificationUnregisterRequestModel } from "./logbogPushNotificationUnregisterRequestModel";
import { logbogPushNotificationHasSubscriptionRequestModel } from "./logbogPushNotificationHasSubscriptionRequestModel";

export class LogbogPushNotificationApi {
  constructor(httpClientService: HttpClientService, userService: AccountService) {
      this.httpClientService = httpClientService;
      this.userService = userService;
  }

  private httpClientService: HttpClientService;
  private userService: AccountService;

  private baseUrl = () => config.logbogApiUrl + "api/pushNotification";
  private vapidPublicKeyUrl = () => `${this.baseUrl()}/vapidPublicKey`;
  private hasSubscriptionUrl = () => `${this.baseUrl()}/hasSubscription`;
  private registerSubscriptionUrl = () => `${this.baseUrl()}/register`;
  private deleteSubscriptionUrl = () => `${this.baseUrl()}/unregister`;

  async getVapidPublicKey(): Promise<string> {
    const url = this.vapidPublicKeyUrl();

    const result = await this.httpClientService.Get<ApiResponse<string>>(url);

    return result.data;
  } 

  async hasSubscription(subscription: PushSubscription): Promise<boolean> {
    const url = this.hasSubscriptionUrl();

    const body: logbogPushNotificationHasSubscriptionRequestModel = {
      pushEndpoint: subscription.endpoint
    }

    const result = await this.httpClientService.Post<ApiResponse<boolean>, logbogPushNotificationHasSubscriptionRequestModel>(url, body);

    return result.data;
  }

  async registerSubscription(subscription: PushSubscription): Promise<boolean> {
    const url = this.registerSubscriptionUrl();

    const subscriptionAsJson = subscription.toJSON();
    const body: LogbogPushNotificationRegisterRequestModel = {
      pushEndpoint: subscriptionAsJson.endpoint,
      pushKeys: subscriptionAsJson.keys
    };
    
    const result = await this.httpClientService.Post<ApiResponse<boolean>, LogbogPushNotificationRegisterRequestModel>(url, body);

    return result.data;
  }

  async unregisterSubscription(subscription: PushSubscription): Promise<boolean> {
    const body: LogbogPushNotificationUnregisterRequestModel = {
      pushEndpoint: subscription.endpoint
    }

    const url = this.deleteSubscriptionUrl();

    const result = await this.httpClientService.Post<ApiResponse<boolean>, LogbogPushNotificationUnregisterRequestModel>(url, body);

    return result.data;
  }
}
